const styles = (theme) => ({
  root: {
    '&.appContent': {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 1300,

      '&.dropShadow': {
        boxShadow: '0 1px 5px rgba(0,0,0, 0.5)',
      },
    },

    '& .MuiSwitch-switchBase.Mui-checked': {
      color: theme.palette.common.coral,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.common.coral,
    },
  },
  toolBar: {
    padding: 0,
  },
  notificationIconContainer: {
    position: 'relative',
    width: '45px',
    cursor: 'pointer',
    margin: '0 20px 0 0',
  },
  backIcon: {
    display: 'flex',
    margin: '0 10px 0 0',
    height: '17px',
    transform: 'rotate(180deg)',
  },
  drawerLaunchContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    height: 35,
    '& span': {
      margin: '0 20px 0 0',
      '&:last-child': {
        marginRight: 0,
      },
    },
  },
});

export default styles;
